<div class="">
  <ng-container [formGroup]="form">
    <ng-container *ngFor="let formItem of questionsAndGroups">
      <ng-container *ngIf="formItem?.questionTypeId">
        <ng-container *ngFor="let item of (formData.questions)" [formGroupName]="item.id">
          <ng-template *ngIf="!item.questionGroupId && item.id == formItem.id" [appQuestion]="item" [readonly]="readonly" [appQuestionParams]="parameters[item.id]" [appQuestionParentForm]="form" [questions]="formData.questions" #question="AppQuestion">
            <mat-card class="" style="display:block!important">
              <div fxLayout="column" id="{{question.param.tag}}"> <!--fxLayout.gt-lg="row wrap"-->
                <div class="px-24">
                  <span style="font-size: 2rem; font-weight: bold;">{{question.param.description}}</span>
                  <span style="font-size: 1rem;" [ngClass]="{
                    'color-isRequired': question.param.isRequired,
                    'color-noRequired': !question.param.isRequired
                    }"> {{question.param.isRequired ? '(Requerido)' : '(Opcional)'}}</span>
                  <p *ngIf="!readonly">{{question.param.explanation}}</p>
                </div>
                <div fxLayout="column wrap" class="px-24" style="display:block!important">
                  <div [ngSwitch]="question.param.type" class="m-4" fxFill>
                    <app-date-input *ngSwitchCase="QUESTION_TYPES.DATE_PICKER" formControlName="answer" [readonly]="readonly" [required]="question?.param?.isRequired"></app-date-input>
                    <app-date-range *ngSwitchCase="QUESTION_TYPES.DATE_RANGE" formControlName="answer" [readonly]="readonly" [required]="question?.param?.isRequired"></app-date-range>
                    <app-text-input *ngSwitchCase="QUESTION_TYPES.TEXT" formControlName="answer" [allowTextArea]="true"></app-text-input>
                    <app-select-input *ngSwitchCase="QUESTION_TYPES.LIST" formControlName="answer"
                      [items]="question.param.items" filterEnabled="true" (setCommentListRequired)="setCommentListRequired($event, question.param, item)"></app-select-input><!---->
                    <app-radio-group-input *ngSwitchCase="QUESTION_TYPES.SINGLE_OPTION" formControlName="answer"
                                          [items]="question.param.items"></app-radio-group-input>
                    <app-select-multiple-input *ngSwitchCase="QUESTION_TYPES.MULTIPLE_ANSWERS" formControlName="answer"
                      [items]="question.param.items" filterEnabled="true"></app-select-multiple-input>
                    <app-text-list-input *ngSwitchCase="QUESTION_TYPES.ANSWERS_LIST"
                                        formControlName="answer"></app-text-list-input>
                    <app-status-selector-input *ngSwitchCase="QUESTION_TYPES.STATUS" formControlName="answer"
                                              [items]="question.param.colorItems"></app-status-selector-input>
                    <app-table-input *ngSwitchCase="QUESTION_TYPES.TABLE" formControlName="answer"
                                    [tableConfig]="question.param.tableConfig"></app-table-input>
                    <app-files-input *ngSwitchCase="QUESTION_TYPES.FILES" formControlName="answer"
                      [initialData]="question.param.files" [uploadEndpoint]="'File/UploadFileFormAnswerTypeAttachment'"></app-files-input>
                    <app-template-input *ngSwitchCase="QUESTION_TYPES.TEMPLATE" formControlName="answer" [readonly]="readonly"
                                        [templateId]="question.param.template" [initialData]="question.param.files"></app-template-input>
                  </div>

                  <div fxLayout="flex wrap">
                    <ng-container formArrayName="comments" *ngIf="question.param.commentAllowed">

                      <button *ngIf="!readonly || (readonly && item.comments.length)"
                          mat-icon-button
                          [color]="question.param.commentRequired ? 'warn' : ''"
                          class="quick-panel-toggle-button"
                          (click)="openChatDialog(item.comments, item.id, question)"
                          aria-label="Open comments chat dialog">
                          <mat-icon 
                              [ngClass]="{'secondary-text': !question.param.commentRequired}"
                              matBadge="{{item.comments.length}}"
                              matBadgeHidden="{{!item.comments.length}}"
                              matBadgeOverlap="true"
                              matBadgePosition="below">
                                chat
                          </mat-icon>
                          <span *ngIf="question.param.commentRequired" class="font-size-20">*</span>
                      </button>

                      <!--SECTION - DO NOT DELETE-->
                      <!-- <ng-container *ngFor="let comment of question.comments.controls; let index = index">
                        <mat-form-field *ngIf="!readonly || (readonly && question.comments.controls[index].value)" class="m-4"
                                      fxFlex="100%">
                        <mat-label>{{'APP.QUESTIONS.COMMENTS' |translate}}</mat-label>
                        <input [formControlName]="index" matInput/>
                      </mat-form-field>
                      </ng-container> -->
                      <!-- //SECTION - DO NOT DELETE-->

                    </ng-container>

                    <ng-container *ngIf="question.param.attachAllowed">
                      <button *ngIf="!readonly || (readonly && question.param.attachments.length)"
                          mat-icon-button
                          [color]="question.param.attachRequired ? 'warn' : ''"
                          class="quick-panel-toggle-button"
                          (click)="openAttachmentsDialog(question.param.attachments, question)"
                          aria-label="Open attachments dialog">
                          <mat-icon 
                              [ngClass]="{'secondary-text': !question.param.attachRequired}"
                              matBadge="{{question.param.attachments.length}}"
                              matBadgeHidden="{{!question.param.attachments.length}}"
                              matBadgeOverlap="true"
                              matBadgePosition="below">
                                insert_drive_file
                          </mat-icon>
                          <span *ngIf="question.param.attachRequired" class="font-size-20">*</span>
                      </button>
                    </ng-container>
                    
                    
                    <!-- <app-simple-file-uploader *ngIf="question.param.attachAllowed"
                                              class="uploader"
                                              #fileUploader
                                              [initialData]="question.param.attachments"
                                              (changes)="setQuestionAttachments(question, $event)" 
                                              allowedExtensions=".png,.jpg,.jpeg,.pdf,.docx,.xls,.xlsx,.webp,.webm"
                                              [endpoint]="uploadQuestionAttachmentEndpoint">

                      <div class="uploader-content">
                        <div *ngFor="let file of fileUploader.rawFiles">
                          <div fxLayout="row wrap" fxLayoutAlign="flex-start center" class="mb-12">
                            <div fxFlex="100%" fxLayoutAlign="flex-start center">
                              <span class="font-weight-600 mb-12">{{'BUTTONS.ATTACHMENTS' | translate}}</span>
                            </div>
                            <span class="cursor-p" (click)="fileUploader.downloadFile(file)">
                              <a>{{file.name}}</a>
                            </span>
                            <button mat-icon-button
                                    *ngIf="!readonly"
                                    (click)="fileUploader.removeFile(file)"><mat-icon>cancel</mat-icon></button>
                          </div>
                        </div>
                        <button mat-raised-button
                                color="accent"
                                [disabled]="form.disabled"
                                *ngIf="!readonly"
                                (click)="fileUploader.openSelectFile()" class="py-8 px-16">
                                <span>{{'BUTTONS.ATTACH' | translate}}</span>
                          <mat-icon>attach_file</mat-icon>
                        </button>
                      </div>
                      <div class="uploading-overlay" *ngIf="fileUploader.filesStatus?.length">
                        <div class="uploading-video-data" *ngFor="let upload of fileUploader.filesStatus">
                          <mat-progress-bar style="grid-area: progress; margin: auto;"
                                            color="accent"
                                            *ngIf="upload.progress"
                                            [mode]="'buffer'"
                                            [value]="upload.status == 1 ? null : upload.progress" >
                          </mat-progress-bar>
                          <button mat-icon-button
                                  [disabled]="readonly"
                                  *ngIf="!readonly"
                                  style="grid-area: cancel" (click)="upload.data.remove()"><mat-icon>cancel</mat-icon></button>

                        </div>
                      </div>

                    </app-simple-file-uploader> -->

                  </div>
                </div>
              </div>
            </mat-card>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!formItem.questionTypeId">
        <ng-container *ngFor="let group of formQuestionsGroups">
          <mat-accordion *ngIf="group.id == formItem.id">
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="my-20">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h2>{{group.description}}</h2>
                </mat-panel-title>
              </mat-expansion-panel-header>
                <ng-container *ngFor="let item of (formData.questions)" [formGroupName]="item.id">
                  <ng-template *ngIf="item.questionGroupId == group.id" [appQuestion]="item" [appQuestionParams]="parameters[item.id]" [appQuestionParentForm]="form" [questions]="formData.questions" #question="AppQuestion">
                    <mat-card class="">
                      <div fxLayout="column wrap" id="{{question.param.tag}}">
                        <div class="px-24">
                          <span style="font-size: 2rem; font-weight: bold;">{{question?.param?.description}}</span>
                          <span style="font-size: 1rem;" [ngClass]="{
                            'color-isRequired': question?.param?.isRequired,
                            'color-noRequired': !question?.param?.isRequired
                            }"> {{question?.param?.isRequired ? '(Requerido)' : '(Opcional)'}}</span>
                          <p *ngIf="!readonly">{{question?.param?.explanation}}</p>
                        </div>
                        <div fxLayout="flex wrap" class="px-24">
                          <div [ngSwitch]="question?.param?.type" class="m-4" fxFill>
                            <app-date-input *ngSwitchCase="QUESTION_TYPES.DATE_PICKER" formControlName="answer" [readonly]="readonly" [required]="question?.param?.isRequired"></app-date-input>
                            <app-date-range *ngSwitchCase="QUESTION_TYPES.DATE_RANGE" formControlName="answer" [readonly]="readonly" [required]="question?.param?.isRequired"></app-date-range>
                            <app-text-input *ngSwitchCase="QUESTION_TYPES.TEXT" formControlName="answer"></app-text-input>
                            <app-select-input *ngSwitchCase="QUESTION_TYPES.LIST" formControlName="answer"
                              [items]="question?.param?.items" filterEnabled="true" (setCommentListRequired)="setCommentListRequired($event, question.param, item)"></app-select-input>
                            <app-radio-group-input *ngSwitchCase="QUESTION_TYPES.SINGLE_OPTION" formControlName="answer"
                                                  [items]="question?.param?.items"></app-radio-group-input>
                            <app-select-multiple-input *ngSwitchCase="QUESTION_TYPES.MULTIPLE_ANSWERS" formControlName="answer"
                              [items]="question?.param?.items" filterEnabled="true"></app-select-multiple-input>
                            <app-text-list-input *ngSwitchCase="QUESTION_TYPES.ANSWERS_LIST"
                                                formControlName="answer"></app-text-list-input>
                            <app-status-selector-input *ngSwitchCase="QUESTION_TYPES.STATUS" formControlName="answer"
                                                      [items]="question?.param?.colorItems"></app-status-selector-input>
                            <app-table-input *ngSwitchCase="QUESTION_TYPES.TABLE" formControlName="answer"
                                            [tableConfig]="question?.param?.tableConfig"></app-table-input>
                            <app-files-input *ngSwitchCase="QUESTION_TYPES.FILES" formControlName="answer"
                              [initialData]="question?.param?.files" [uploadEndpoint]="'File/UploadFileFormAnswerTypeAttachment'"></app-files-input>
                            <app-template-input *ngSwitchCase="QUESTION_TYPES.TEMPLATE" formControlName="answer" [readonly]="readonly"
                                                [templateId]="question?.param?.template" [initialData]="question?.param?.files"></app-template-input>
                          </div>
            
                          <div fxLayout="flex wrap">
                            <ng-container formArrayName="comments" *ngIf="question?.param?.commentAllowed">
            
                              <button *ngIf="!readonly || (readonly && item.comments.length)"
                                  mat-icon-button
                                  [color]="question?.param?.commentRequired ? 'warn' : ''"
                                  class="quick-panel-toggle-button"
                                  (click)="openChatDialog(item.comments, item.id, question)"
                                  aria-label="Open comments chat dialog">
                                  <mat-icon 
                                      [ngClass]="{'secondary-text': !question?.param?.commentRequired}"
                                      matBadge="{{item.comments.length}}"
                                      matBadgeHidden="{{!item.comments.length}}"
                                      matBadgeOverlap="true"
                                      matBadgePosition="below">
                                        chat
                                  </mat-icon>
                                  <span *ngIf="question?.param?.commentRequired" class="font-size-20">*</span>
                              </button>
            
                            </ng-container>
            
                            <ng-container *ngIf="question?.param?.attachAllowed">
                              <button *ngIf="!readonly || (readonly && question?.param?.attachments.length)"
                                  mat-icon-button
                                  [color]="question?.param?.attachRequired ? 'warn' : ''"
                                  class="quick-panel-toggle-button"
                                  (click)="openAttachmentsDialog(question?.param?.attachments, question)"
                                  aria-label="Open attachments dialog">
                                  <mat-icon 
                                      [ngClass]="{'secondary-text': !question?.param?.attachRequired}"
                                      matBadge="{{question?.param?.attachments.length}}"
                                      matBadgeHidden="{{!question?.param?.attachments.length}}"
                                      matBadgeOverlap="true"
                                      matBadgePosition="below">
                                        insert_drive_file
                                  </mat-icon>
                                  <span *ngIf="question?.param?.attachRequired" class="font-size-20">*</span>
                              </button>
                            </ng-container>
                            
                          </div>
                        </div>
                      </div>
                    </mat-card>
                  </ng-template>
                </ng-container>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
